var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"w-100 d-flex flex-column"},[_c('div',{staticClass:"paginated-list-wrapper row"},[_vm._t("default")],2),_c('div',{staticClass:"text-center pagination-class"},[(!_vm.hidePagination)?_c('Pagination',_vm._g(_vm._b({},'Pagination',Object.assign({}, _vm.paginationProps,
        {total: _vm.totalItems,
        pageSize: _vm.pageSize,
        updateLocally: _vm.inContainer}),false),_vm.$listeners)):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }